import { Input, Label, NumberInput } from "@tellescope/ui";
import { Select } from "@tellescope/design-system";
import { useTranslation } from "react-i18next";
import { MedicationResponse } from "@tellescope/types-models";

export interface MedicationDosageFieldsProps {
  medication: MedicationResponse;
  onChange: (medication: MedicationResponse) => void;
  fieldId?: string;
}

export const MedicationDosageFields = ({ medication, onChange, fieldId }: MedicationDosageFieldsProps) => {
  const { t } = useTranslation("forms");
  const quantityId = fieldId ? `${fieldId}-quantity` : undefined;
  const frequencyId = fieldId ? `${fieldId}-frequency` : undefined;
  const reasonId = fieldId ? `${fieldId}-reason` : undefined;

  return (
    <>
      <div className="flex gap-2">
        <div className="flex-1 space-y-1">
          <Label htmlFor={quantityId}>{t("Units (e.g. capsule, table, puff) per dose?")}</Label>
          <NumberInput
            id={quantityId}
            value={medication.dosage?.quantity ? parseInt(medication.dosage.quantity) : undefined}
            onChange={(quantity) =>
              onChange({
                ...medication,
                dosage: {
                  ...medication.dosage,
                  quantity: String(quantity),
                  value: medication.dosage?.value ?? "",
                  unit: medication.dosage?.unit ?? "",
                },
              })
            }
            placeholder={t("Units (e.g. capsule, table, puff) per dose?")}
            className="w-full"
          />
        </div>
        <div className="flex-1 space-y-1">
          <Label htmlFor={frequencyId}>{t("How many times per day?")}</Label>
          <Select
            value={medication.dosage?.frequency}
            onValueChange={(frequency) =>
              onChange({
                ...medication,
                dosage: {
                  ...medication.dosage,
                  frequency,
                  value: medication.dosage?.value ?? "",
                  unit: medication.dosage?.unit ?? "",
                },
              })
            }
          >
            <Select.Trigger id={frequencyId} className="w-full">
              {medication.dosage?.frequency ? <Select.Value /> : t("How many times per day?")}
            </Select.Trigger>
            <Select.Content>
              <Select.Item value="1">1</Select.Item>
              <Select.Item value="2">2</Select.Item>
              <Select.Item value="3">3</Select.Item>
              <Select.Item value="4">4</Select.Item>
              <Select.Item value="5">5</Select.Item>
              <Select.Item value="6">6</Select.Item>
              <Select.Item value="As Needed">{t("As Needed")}</Select.Item>
            </Select.Content>
          </Select>
        </div>
      </div>
      <div className="space-y-1">
        <Label htmlFor={reasonId}>{t("Reason for taking medication")}</Label>
        <Input
          id={reasonId}
          value={medication.reasonForTaking}
          onChange={(e) => onChange({ ...medication, reasonForTaking: e.target.value })}
          placeholder={t("Reason for taking medication")}
        />
      </div>
    </>
  );
};
